<fieldset class="inputGroup tw-mb-10" [formGroup]="form">
  <legend>{{ 'profile.contactInformation' | translate }}</legend>
  <div class="row">
    <div class="col-lg-12 input-panel">
      <div class="input-label">{{ 'forms.profileDetails.address' | translate }}*</div>
      <div class="input-field">
        <textarea class="form-control" rows="3" formControlName="address"></textarea>
      </div>
      <app-validation-error-message
        [inputName]="'forms.profileDetails.address' | translate"
        [showFormError]="showFormError"
        [control]="form.get('address')"
      >
      </app-validation-error-message>
    </div>
    <div class="col-lg-6 input-panel">
      <div class="input-label">{{ 'forms.profileDetails.postcode' | translate }}*</div>
      <div class="input-field">
        <input
          class="form-control"
          formControlName="postcode"
          type="text"
          alphanumeric
          maxlength="20"
        />
      </div>
      <app-validation-error-message
        [inputName]="'forms.profileDetails.postcode' | translate"
        [showFormError]="showFormError"
        [control]="form.get('postcode')"
      >
      </app-validation-error-message>
    </div>
    <div class="col-lg-6 input-panel">
      <div class="input-label">{{ 'forms.profileDetails.city' | translate }}*</div>
      <div class="input-field">
        <input class="form-control" formControlName="city" type="text" />
      </div>
      <app-validation-error-message
        [inputName]="'forms.profileDetails.city' | translate"
        [showFormError]="showFormError"
        [control]="form.get('city')"
      >
      </app-validation-error-message>
    </div>
    <div class="col-lg-6 input-panel">
      <div class="input-label">{{ 'forms.profileDetails.countryId' | translate }}*</div>
      <div class="input-field">
        <mat-select
          [placeholder]="'common.selectPlaceholder' | translate"
          class="form-control"
          formControlName="countryId"
          (selectionChange)="changeCountry(form.value.countryId)"
        >
          <mat-option
            *ngFor="let country of countries; let i = index"
            [value]="country.isoCode"
            [class.tw-border-b]="i === prioritisedCountriesCount - 1"
            [class.tw-border-gray-300]="i === prioritisedCountriesCount - 1"
          >
            {{ country.name }}
          </mat-option>
        </mat-select>
      </div>
      <app-validation-error-message
        [inputName]="'forms.profileDetails.countryId' | translate"
        [showFormError]="showFormError"
        [control]="form.get('countryId')"
      >
      </app-validation-error-message>
    </div>
    <div class="col-lg-6 input-panel" *ngIf="states?.length > 0">
      <div class="input-label">{{ 'forms.profileDetails.stateId' | translate }}*</div>
      <div class="input-field">
        <mat-select
          [placeholder]="'common.selectPlaceholder' | translate"
          class="form-control"
          formControlName="stateId"
        >
          <mat-option *ngFor="let state of states" [value]="state.isoCode">
            {{ state.name }}
          </mat-option>
        </mat-select>
      </div>
      <app-validation-error-message
        [inputName]="'forms.profileDetails.stateId' | translate"
        [showFormError]="showFormError"
        [control]="form.get('stateId')"
      >
      </app-validation-error-message>
    </div>
    <div class="col-lg-12 input-panel">
      <div class="row">
        <div class="col-lg-6">
          <div class="input-label">{{ 'forms.profileDetails.phoneNumber' | translate }}*</div>
          <div class="input-field phone-input-field">
            <mat-select class="form-control countryCode" formControlName="phoneCountryCode">
              <mat-select-trigger>
                {{ form.value.phoneCountryCode }}
              </mat-select-trigger>
              <mat-option
                *ngFor="let country of countries; let i = index"
                [value]="country.phonecode"
                [class.tw-border-b]="i === prioritisedCountriesCount - 1"
                [class.tw-border-gray-300]="i === prioritisedCountriesCount - 1"
              >
                {{ country.name }} ({{ country.phonecode }})
              </mat-option>
            </mat-select>

            <input class="form-control" formControlName="phoneNumber" type="text" digitOnly />
          </div>
          <app-validation-error-message
            [inputName]="'forms.profileDetails.phoneNumber' | translate"
            [showFormError]="showFormError"
            [control]="form.get('phoneNumber')"
          >
          </app-validation-error-message>
        </div>
      </div>
    </div>
  </div>
</fieldset>
